// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\nh1[data-v-26c42a54]{ text-align: center; font-weight: normal; color:var(--main-gray-6);\n}\nh2[data-v-26c42a54]{ text-align: center; font-weight: normal; color:var(--main-gray-5);\n}\nul.options[data-v-26c42a54]{ padding-left:0; margin-left: 0;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
